export const PAGELIST = '/v1/message/messageRecord/pageList/';
export const DELETEMSG = '/v1/message/messageRecord/';
export const DELETEBATCH = '/v1/message/messageRecord/batch';
